import { Component, Input, OnInit } from "@angular/core";

import { ViewCell } from "ng2-smart-table";

@Component({
  template: `<span class="text-hint" style="text-align: left;">
    {{ renderValue | date: "dd/MM/yyyy HH:mm" }}
  </span>`,
})
export class StbCustomRenderDateComponent implements ViewCell, OnInit {
  renderValue: Date;

  @Input() value: string;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue = !this.value ? new Date() : new Date(this.value);
  }
}
